export class ValidateAtsConnectionResponseError extends Error {
  error_code: 'ats_connection_invalid' | string;
  reason?: string;

  constructor(reason: string | undefined, error_code: 'ats_connection_invalid' | string) {
    super(reason);
    this.name = 'ValidateAtsConnectionResponseError';
    this.error_code = error_code;
    this.reason = reason;
  }
}
